import React from 'react';

export const PatientSkeleton = () => (
  <div className='animate-pulse w-full px-3 py-2 mb-1'>
    <div className='h-3.5 bg-gray-200 rounded w-32 mb-2' />
    <div className='h-2.5 bg-gray-200 rounded w-20' />
  </div>
);

export const PatientSkeletonList = ({ count = 5 }: { count?: number }) => (
  <div aria-hidden='true'>
    {Array.from({ length: count }).map((_, i) => <PatientSkeleton key={i} />)}
  </div>
);

interface EmptyStateProps {
  icon?: string;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export const EmptyState = ({ icon = '👥', title, subtitle, action }: EmptyStateProps) => (
  <div className='px-4 py-8 text-center text-xs text-gray-500'>
    <div className='text-3xl mb-2 select-none' aria-hidden='true'>{icon}</div>
    <div className='font-medium text-gray-700 mb-1'>{title}</div>
    {subtitle && <div className='text-gray-400 mb-3 max-w-[14rem] mx-auto leading-4'>{subtitle}</div>}
    {action}
  </div>
);
